/**
 * region for libraries*/
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import {
  Grid,
  Paper,
  Box,
  Typography,
  ButtonGroup,
  Badge,
  Chip,
  LinearProgress,
  Snackbar,
  Collapse,
  Switch,
  CircularProgress,
  Button,
} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import ContentEditable from "react-contenteditable";
import sanitizeHtml from "sanitize-html";
import Add from "@material-ui/icons/Add";

import { commonFunction } from "../../helpers/commonFunction";

/**
 * region for styles*/
import { keywordAnalyzerStyle } from "./style/keywordAnalyzerStyle";

/**
 * region for components*/
import { WizardAddKeywordModal } from '../../components/common/AddKeywordModal/WizardAddKeywordModal'
/**
 * region for hepers*/
import ajax from "../../helpers/ajax";
import Constants from "../../constants/Constants";
import typing from "../../helpers/typing";

import { debounce } from "lodash";

const MESSAGES = {
  ERROR_ADD_KEYWORD: "Error to add keyword",
  ERROR_EXIST_KEYWORD: "This already exists as a keyword",
  ERROR_EXIST_SYNONYM: "This already exists as a synonym",
  ERROR_LIMIT_STRING_EXCEEDS: "Selection exceeds the character limit",
  ERROR_EXIST_IN_LIST: "This is already in the list of keywords to add",
  ERROR_ADD_KEYWORD_DUPLICATE: "This is already added",
  ERROR_INVALID: "Selection is invalid",
  ERROR_SAVE: "Error to save keywords",
  SAVE: "were added",
};

class KeywordAnalyzer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: Constants.MODE_LOADED,
      inputText: "",
      listKeywordsInElasticSearch: [],
      listKeywordsToAdd: [],
      selectText: "",
      mouseX: null,
      mouseY: null,
      currentlyContextMenuX: null,
      currentlyContextMenuY: null,
      openContextMenu: false,
      messageSnackbar: "",
      openSnackbar: false,
      typeAlert: Constants.ALERT_INFO,
      showKeywordElasticSearch: false,
      modeAdd: Constants.MODE_LOADED,
      modeSave: Constants.MODE_LOADED,
      modeAddMultiple: Constants.MODE_LOADED,
      showAddKeywordModal: false,
      keywordsSelect: [],
      keywordText:'',
    };

    this.servicesElasticSearchKeyword = debounce(this.servicesElasticSearchKeyword);
  }

  componentDidMount() {
    this.load();
  }

  load() {
    const self = this;

    ajax.get(Constants.ROUTE_API_COMMONDATA,
        {
            success: function (response) {
                self.setState({
                    backofficeUrlBase: response.data.urlBackofficeBase,
                    mode: Constants.MODE_LOADED
                });
            }
        });
  } 

  handleOnMouseUp(event) {
    let self = this;
    let x = 0;
    let y = 0;
    let showContextMenu = false;
    let selectText = "";
    let objectText = null;

    if (document.getSelection) {
      // all browsers, except IE before version 9
      objectText = document.getSelection();
      if (!typing.isEmpty(objectText)) {
        selectText = objectText.toString();
      }
    } else {
      if (document.selection) {
        // Internet Explorer before version 9
        objectText = document.selection.createRange();
        if (!typing.isEmpty(objectText)) {
          selectText = objectText.text.toString();
        }
      }
    }

    if (!typing.isEmpty(self.state.inputText) && typing.isEmpty(selectText)) {
      self.setState({
        openContextMenu: false,
      });
    }

    if (!objectText !== null && !typing.isEmpty(selectText)) {
      let coordenadas = objectText.getRangeAt(0).getBoundingClientRect();
      if (coordenadas.width !== null && coordenadas.width >= 1) {
        x = coordenadas.x + coordenadas.width / 2;
        y = coordenadas.y + (coordenadas.height + 40);
        showContextMenu = true;
      }
    }

    if (!typing.isEmpty(selectText)) {
      self.setState({
        currentlyContextMenuX: x,
        currentlyContextMenuY: y,
        selectText: selectText,
        openContextMenu: showContextMenu,
      });
    }
  }

  handleOnScroll(event) {
    let self = this;
    var sel = window.getSelection();
    sel.removeAllRanges();

    self.setState({
      currentlyContextMenuX: null,
      currentlyContextMenuY: null,
      selectText: "",
      openContextMenu: false,
    });
  }

  handleOnChange(event) {
    let self = this;
    let changedText = event.target.value;
    self.setState({ inputText: changedText });
  }

  handleOnClickSearchKeywords(event) {
    let self = this;
    self.servicesElasticSearchKeyword(self.state.inputText);
  }

  handleOnPaste(event) {
    let self = this;
    setTimeout(function () {
      var linesText = document.getElementById("editable");
      if (!typing.isEmpty(linesText.innerHTML)) {
        let sanitizeConf = {
          allowedTags: ["div", "p", "br"],
          allowedAttributes: {},
        };
        let cleanText = sanitizeHtml(linesText.innerHTML, sanitizeConf);
        self.setState({
          inputText: cleanText,
        });
      }
    }, 1);
  }

  handleOnClickContextMenu(event) {
    let self = this;
    let selectText = self.state.selectText;

    selectText = commonFunction.replaceNonAdmitedSymbols(selectText);
    selectText = selectText.trim().replaceAll(/\s\s+/g, ' ');
    
    let listKeywordsToAdd = self.state.listKeywordsToAdd;

    self.setState({
      modeAdd: Constants.MODE_LOADING,
    });

    if (selectText.length > Constants.MAX_KEYWORD_LENGTH) {
      self.setState({
        messageSnackbar: MESSAGES.ERROR_LIMIT_STRING_EXCEEDS,
        openSnackbar: true,
        typeAlert: Constants.ALERT_ERROR,
        currentlyContextMenuX: null,
        currentlyContextMenuY: null,
        openContextMenu: false,
        selectText: "",
        modeAdd: Constants.MODE_LOADED,
      });
      return;
    }

    if (
      listKeywordsToAdd
        .map(function (item) {
          return commonFunction.replaceNonAdmitedSymbols(item.KEYWORD);
        })
        .indexOf(selectText) !== -1
    ) {
      self.setState({
        messageSnackbar: MESSAGES.ERROR_EXIST_IN_LIST,
        openSnackbar: true,
        typeAlert: Constants.ALERT_ERROR,
        currentlyContextMenuX: null,
        currentlyContextMenuY: null,
        openContextMenu: false,
        selectText: "",
        modeAdd: Constants.MODE_LOADED,
      });
      return;
    }

    let requestData = {
      keyword: selectText,
    };
    ajax.get(Constants.ROUTE_API_CONTENT_KEYWORDS_IS_VALID_TO_ADD, {
      requestData: requestData,
      success: function (response) {
        if (response.success) {
          let newArrayKeyword = [];
          newArrayKeyword.push({ KEYWORD: selectText });
          let requestData = newArrayKeyword.map(function (item) {
            return item.KEYWORD;
          });
          self.GetCounterToKeywordCompany(requestData).then((item) => {
            item.KEYWORDS_COUNTERS.forEach(function (item) {
              listKeywordsToAdd.push({ KEYWORD: commonFunction.replaceNonAdmitedSymbols(item.keyword), COUNTER_COMPANY: item.counter, CATEGORIES:[] });
            });

            self.setState({
              listKeywordsToAdd: listKeywordsToAdd,
              currentlyContextMenuX: null,
              currentlyContextMenuY: null,
              openContextMenu: false,
              selectText: "",
              modeAdd: Constants.MODE_LOADED,
            });
          });
        }
      },
      error: function (response) {
        let results = JSON.parse(response);
        let message = "";
        switch (results.error) {
          case "1":
            message = MESSAGES.ERROR_EXIST_KEYWORD;
            break;
          case "2":
            message = MESSAGES.ERROR_EXIST_SYNONYM;
            break;
          default:
            message = MESSAGES.ERROR_ADD_KEYWORD;
        }
        self.setState({
          messageSnackbar: message,
          openSnackbar: true,
          typeAlert: Constants.ALERT_ERROR,
          currentlyContextMenuX: null,
          currentlyContextMenuY: null,
          openContextMenu: false,
          selectText: "",
          modeAdd: Constants.MODE_LOADED,
        });
      },
    });
  }

  handleOnCloseSnackbar() {
    let self = this;
    self.setState({
      messageSnackbar: "",
      openSnackbar: false,
    });
  }

  handleOnChangeSwitch(event) {
    let self = this;
    self.setState({
      showKeywordElasticSearch: !self.state.showKeywordElasticSearch,
    });
  }

  handleDeleteKeyword(i, event) {
    let self = this;
    let newList = self.state.listKeywordsToAdd;
    newList.splice(i, 1);
    self.setState({
      listKeywordsToAdd: newList,
    });
  }

  handleAddCategories(i, keyword, event){
    let self = this;
    self.setState({
      showAddKeywordModal: true,
      keywordText:keyword.toLowerCase()
    });
  }

  handleOnSave(event) {
    let self = this;

    self.setState({
      modeSave: Constants.MODE_LOADING,
    });

    if (self.state.listKeywordsToAdd.length <= 0) {
      self.setState({
        messageSnackbar: MESSAGES.ERROR_SAVE,
        openSnackbar: true,
        typeAlert: Constants.ALERT_ERROR,
      });
    } else {
      let newArrayOnlyText = [];
      self.state.listKeywordsToAdd.forEach(function (item) {
        var temp = item.KEYWORD.trimStart().trimEnd();
        if (!typing.isEmpty(item))
          if (newArrayOnlyText.indexOf(temp.KEYWORD) === -1) {
            newArrayOnlyText.push({Name: commonFunction.replaceNonAdmitedSymbols(item.KEYWORD).trimStart().trimEnd(), IdsCategories:item.CATEGORIES});
          }
      });

      let requestData = {
        List: newArrayOnlyText,
      };
      ajax.post(Constants.ROUTE_API_CONTENT_KEYWORDS_MULTIPLE, {
        requestData: requestData,
        success: function (response) {
          if (response.success) {
            let message = newArrayOnlyText.length + " " + (newArrayOnlyText.length <= 1 ? "keyword " : "keywords ") + MESSAGES.SAVE;
            self.setState({
              modeSave: Constants.MODE_LOADED,
              modeAdd: Constants.MODE_LOADED,
              mode: Constants.MODE_LOADED,
              inputText: "",
              listKeywordsInElasticSearch: [],
              listKeywordsToAdd: [],
              currentlyContextMenuX: null,
              currentlyContextMenuY: null,
              openContextMenu: false,
              selectText: "",
              showKeywordElasticSearch: false,
              messageSnackbar: message,
              openSnackbar: true,
              typeAlert: Constants.ALERT_SUCCESS,
            });
          } else {
            self.setState({
              messageSnackbar: MESSAGES.ERROR_SAVE,
              openSnackbar: true,
              typeAlert: Constants.ALERT_ERROR,
            });
          }
        },
      });
    }
  }

  handleOnClickLowerCase(event) {
    let self = this;
    let inputTextLowerCase = self.state.inputText.toLowerCase();
    self.setState({
      inputText: inputTextLowerCase,
    });
  }

  handleOnClickAddAllKeywords(event) {
    let self = this;
    var linesText = document.getElementById("editable");
    if (!typing.isEmpty(linesText.innerText)) {
      self.setState({
        modeAddMultiple: Constants.MODE_LOADING,
      });
      self.readKeyword(linesText.innerText.split("\n"));
    }
  }

  readKeyword(arrayText) {
    let self = this;
    let newArrayLinesTextMissingToValidate = [];
    let newArrayErrorLine = [];
    arrayText.forEach(function (lineText) {
      let selectText = commonFunction.replaceNonAdmitedSymbols(lineText);
      selectText = selectText.trim().replaceAll(/\s\s+/g, ' ');

      if (typing.isEmpty(selectText)) {
        return;
      }

      if (newArrayLinesTextMissingToValidate.some((x) => x.KEYWORD === selectText)) {
        
        newArrayErrorLine.push({ KEYWORD: selectText, ERROR: MESSAGES.ERROR_ADD_KEYWORD_DUPLICATE });
        return;
      }

      if (selectText.length > Constants.MAX_KEYWORD_LENGTH) {
        newArrayErrorLine.push({ KEYWORD: selectText, ERROR: MESSAGES.ERROR_LIMIT_STRING_EXCEEDS });
        return;
      }

      if (
        self.state.listKeywordsToAdd
          .map(function (item) {
            return item.KEYWORD;
          })
          .indexOf(selectText) !== -1
      ) {
        newArrayErrorLine.push({ KEYWORD: selectText, ERROR: MESSAGES.ERROR_EXIST_IN_LIST });
        return;
      }

      newArrayLinesTextMissingToValidate.push({ KEYWORD: selectText });
    });
    self.processValidKeywords(newArrayLinesTextMissingToValidate, newArrayErrorLine);
  }

  processValidKeywords(newArrayLinesTextMissingToValidate, newArrayErrorLine) {
    let self = this;
    let listKeywordsToAdd = self.state.listKeywordsToAdd;
    let newArrayKeyword = [];

    if (newArrayLinesTextMissingToValidate.length > 0) {
      let requestData = newArrayLinesTextMissingToValidate.map(function (item) {
        return commonFunction.replaceNonAdmitedSymbols(item.KEYWORD);
      });
      ajax.post(Constants.ROUTE_API_CONTENT_KEYWORDS_IS_VALID_TO_ADD_MULTIPLE, {
        requestData: requestData,
        success: function (response) {
          if (response.success) {
            response.data.forEach(function (item) {
              if (item.ERROR === 0) {
                newArrayKeyword.push({ KEYWORD: commonFunction.replaceNonAdmitedSymbols(item.KEYWORD) });
              } else {
                let message = MESSAGES.ERROR_ADD_KEYWORD;
                switch (item.ERROR) {
                  case 1:
                    message = MESSAGES.ERROR_EXIST_KEYWORD;
                    break;
                  case 2:
                    message = MESSAGES.ERROR_EXIST_SYNONYM;
                    break;
                  default:
                    break;
                }
                newArrayErrorLine.push({ LINE: item.LINE, KEYWORD: commonFunction.replaceNonAdmitedSymbols(item.KEYWORD), ERROR: message });
              }
            });

            let errors = "";
            newArrayErrorLine.forEach(function (lineError) {
              errors += " Keyword: " + lineError.KEYWORD + ", " + lineError.ERROR + "\n";
            });

            let openSnackbar = false;
            if (newArrayErrorLine.length > 0) {
              openSnackbar = true;
            }

            let requestData = newArrayKeyword.map(function (item) {
              return commonFunction.replaceNonAdmitedSymbols(item.KEYWORD);
            });
            self.GetCounterToKeywordCompany(requestData).then((item) => {
              item.KEYWORDS_COUNTERS.forEach(function (item) {
                listKeywordsToAdd.push({ KEYWORD: commonFunction.replaceNonAdmitedSymbols(item.keyword), COUNTER_COMPANY: item.counter, CATEGORIES:[] });
              });

              self.setState({
                messageSnackbar: errors,
                openSnackbar: openSnackbar,
                typeAlert: Constants.ALERT_ERROR,
                currentlyContextMenuX: null,
                currentlyContextMenuY: null,
                openContextMenu: false,
                selectText: "",
                modeAddMultiple: Constants.MODE_LOADED,
                listKeywordsToAdd: listKeywordsToAdd,
              });
            });
          }
        },
      });
    } else {
      let errors = "";
      newArrayErrorLine.forEach(function (lineError) {
        errors += " Keyword: " + lineError.KEYWORD + ", " + lineError.ERROR + "\n";
      });

      let openSnackbar = false;
      if (newArrayErrorLine.length > 0) {
        openSnackbar = true;
      }

      self.setState({
        messageSnackbar: errors,
        openSnackbar: openSnackbar,
        typeAlert: Constants.ALERT_ERROR,
        currentlyContextMenuX: null,
        currentlyContextMenuY: null,
        openContextMenu: false,
        selectText: "",
        modeAddMultiple: Constants.MODE_LOADED,
      });
    }
  }

  servicesElasticSearchKeyword(originalText) {
    let self = this;

    if (!typing.isEmpty(originalText.trimStart().trimEnd())) {
      let cleanHighlightInputText = self.cleanHighlighKeywords(originalText);
      cleanHighlightInputText = cleanHighlightInputText.trim().replaceAll(/\s\s+/g, ' ');

      self.setState({
        mode: Constants.MODE_LOADING,
        inputText: cleanHighlightInputText,
      });

      let sanitizeConf = {
        allowedTags: [""], 
        allowedAttributes: {},
      };
      cleanHighlightInputText = self.replaceAll(cleanHighlightInputText, "<br>", " ");
      cleanHighlightInputText = self.replaceAll(cleanHighlightInputText, "<br/>", " ");
      let cleanText = sanitizeHtml(cleanHighlightInputText, sanitizeConf);

      if (!typing.isEmpty(cleanText)) {
        let requestData = {
          text: cleanText,
        };

        ajax.post(Constants.ROUTE_API_CONTENT_KEYWORDS_ANALYZER, {
          requestData: requestData,
          success: function (response) {
            let listKeywordsInElasticSearch = [];
            if (response.success && !typing.isEmpty(response.data)) {
              response.data.forEach(function (item) {
                var keyword = item.trimStart().trimEnd();
                if (!typing.isEmpty(keyword)) {
                  if (listKeywordsInElasticSearch.indexOf(keyword) === -1) {
                    listKeywordsInElasticSearch.push(keyword);
                  }
                }
              });
              let textWithHighlights = self.showHighlighKeywords(self.state.inputText, listKeywordsInElasticSearch);
              self.setState({
                listKeywordsInElasticSearch: listKeywordsInElasticSearch,
                inputText: textWithHighlights,
                mode: Constants.MODE_LOADED,
                currentlyContextMenuX: 0,
                currentlyContextMenuY: 0,
                selectText: "",
                openContextMenu: false,
              });
            } else {
              self.setState({
                mode: Constants.MODE_LOADED,
                listKeywordsInElasticSearch: [],
                currentlyContextMenuX: 0,
                currentlyContextMenuY: 0,
                selectText: "",
                openContextMenu: false,
              });
            }
          },
        });
      } else {
        self.setState({
          mode: Constants.MODE_LOADED,
          listKeywordsInElasticSearch: [],
          currentlyContextMenuX: 0,
          currentlyContextMenuY: 0,
          selectText: "",
          openContextMenu: false,
        });
      }
    } else {
      self.setState({
        mode: Constants.MODE_LOADED,
        listKeywordsInElasticSearch: [],
        currentlyContextMenuX: null,
        currentlyContextMenuY: null,
        selectText: "",
        openContextMenu: false,
      });
    }
  }

  replaceAll(str, find, replace) {
    let s = str.replace(new RegExp(find, "gi"), replace);
    return s;
  }

  escapeStringRegExp(str) {
    let escapeStringRegExpmatchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
    return str.replace(escapeStringRegExpmatchOperatorsRe, "\\$&");
  }

  cleanHighlighKeywords(newInputText) {
    let self = this;
    let textWithHighlighed = newInputText;
    textWithHighlighed = self.replaceAll(textWithHighlighed, 'xprt style="(.*?)', "xprt");
    textWithHighlighed = self.replaceAll(textWithHighlighed, "rgb\\(251, 192, 45\\)(.*?)", "none");
    textWithHighlighed = self.replaceAll(textWithHighlighed, "<xprt>", "");
    textWithHighlighed = self.replaceAll(textWithHighlighed, "</xprt>", "");
    return textWithHighlighed;
  }

  showHighlighKeywords(newInputText, listKeywordsInElasticSearch) {
    let self = this;
    let textWithHighlighed = newInputText;
    let listOrder = listKeywordsInElasticSearch.sort(function (a, b) {
      return b.length - a.length;
    });
    listOrder.forEach(function (item) {
      var itemReg = self.escapeStringRegExp(item);
      textWithHighlighed = self.replaceAll(textWithHighlighed, itemReg, "<xprt>" + item + "</xprt>");
    });
    return textWithHighlighed;
  }

  GetCounterToKeywordCompany(requestData) {
    return new Promise((resolve, reject) => {
      ajax.post(Constants.ROUTE_API_CONTENT_COMPANY_BY_KEYWORDS, {
        requestData: requestData,
        success: function (response) {
          resolve({ KEYWORDS_COUNTERS: response.data.keywordTermCounter });
        },
      });
    });
  }

  getCursorPointer() {
    var element = document.getElementById("editable");
    let position = 0;
    const isSupported = typeof window.getSelection !== "undefined";
    if (isSupported) {
      const selection = window.getSelection();
      if (selection.rangeCount !== 0) {
        const range = window.getSelection().getRangeAt(0);
        const preCaretRange = range.cloneRange();
        preCaretRange.selectNodeContents(element);
        preCaretRange.setEnd(range.endContainer, range.endOffset);
        position = preCaretRange.toString().length;
      }
    }
    return position;
  }

  createRange(node, chars, range) {
    let self = this;
    if (!range) {
      range = document.createRange();
      range.selectNode(node);
      range.setStart(node, 0);
    }
    if (chars.count === 0) {
      range.setEnd(node, chars.count);
    } else if (node && chars.count > 0) {
      if (node.nodeType === Node.TEXT_NODE) {
        if (node.textContent.length < chars.count) {
          chars.count -= node.textContent.length;
        } else {
          range.setEnd(node, chars.count);
          chars.count = 0;
        }
      } else {
        for (var lp = 0; lp < node.childNodes.length; lp++) {
          range = self.createRange(node.childNodes[lp], chars, range);

          if (chars.count === 0) {
            break;
          }
        }
      }
    }
    return range;
  }

  handleOnCloseAddKeywordModal() {
    this.setState({ showAddKeywordModal: false });
  }

  handleRefreshRelateKeywords() {
    this.setState({ showAddKeywordModal: false });
  }

  returnObjects = (items) => {
    let newArrayOnlyText = [];
    console.log(items)
    console.log(this.state.listKeywordsToAdd)
    this.state.listKeywordsToAdd.forEach(function (item) {
        if (items.Name.toLowerCase()===item.KEYWORD.toLowerCase()){
          newArrayOnlyText.push({ KEYWORD:item.KEYWORD, COUNTER_COMPANY: item.COUNTER_COMPANY, CATEGORIES:items.IdList });
        }else{
          newArrayOnlyText.push({ KEYWORD:item.KEYWORD, COUNTER_COMPANY: item.COUNTER_COMPANY, CATEGORIES:item.CATEGORIES });
        }              
    });
    this.setState({
      listKeywordsToAdd: newArrayOnlyText,
    });
  }

  render() {
    let self = this;

    const { classes } = this.props;
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

    let addKeywordIcon;
    if (self.state.modeAdd === Constants.MODE_LOADING) {
      addKeywordIcon = <CircularProgress size={10} className={classes.progressAdd} />;
    } else {
      addKeywordIcon = <Add className={classes.buttonAddKeywordIcon} />;
    }

    let showAddKeywordModal=this.state.showAddKeywordModal;
    return (
      <Grid className={classes.contentAll} container spacing={0}>
        <Grid item xs={12} md={12} lg={12}>
          <Paper className={fixedHeightPaper}>
            <Grid container spacing={3}>
              <Grid item xs={8} md={8} lg={8}>
                <Grid container spacing={0}>
                  <Grid item xs={12} md={12} lg={12}>
                    <Box component="div" className={classes.menuContentEditable}>
                      <ButtonGroup variant="text">
                        <Button
                          size="large"
                          onClick={self.handleOnClickSearchKeywords.bind(this)}
                          disabled={typing.isEmpty(self.state.inputText) ? true : false}
                        >
                          Find Keywords
                        </Button>
                        <Button size="large" onClick={self.handleOnClickLowerCase.bind(this)} disabled={typing.isEmpty(self.state.inputText) ? true : false}>
                          Lower Case
                        </Button>
                        <Button
                          size="large"
                          onClick={self.handleOnClickAddAllKeywords.bind(this)}
                          disabled={self.state.modeAddMultiple === Constants.MODE_LOADING || typing.isEmpty(self.state.inputText) ? true : false}
                        >
                          {self.state.modeAddMultiple === Constants.MODE_LOADING && <CircularProgress size={10} className={classes.progressAddMultiple} />}
                          Add all keywords
                        </Button>
                      </ButtonGroup>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={12} lg={12}>
                    <ContentEditable
                      id="editable"
                      className={classes.contentEditable}
                      html={self.state.inputText}
                      disabled={false}
                      onChange={self.handleOnChange.bind(this)}
                      onPaste={self.handleOnPaste.bind(this)}
                      onMouseUp={self.handleOnMouseUp.bind(this)}
                      onScroll={self.handleOnScroll.bind(this)}
                    />

                    {self.state.mode === Constants.MODE_LOADING && <LinearProgress className={classes.linearProgress} />}
                    <div
                      className={classes.tools}
                      style={{
                        display: self.state.openContextMenu ? "" : "none",
                        top: self.state.currentlyContextMenuY,
                        left: self.state.currentlyContextMenuX,
                      }}
                    >
                      <div>
                        <Button
                          size="small"
                          onClick={self.handleOnClickContextMenu.bind(this)}
                          disabled={self.state.modeAdd === Constants.MODE_LOADING ? true : false}
                          className={classes.buttonAddKeyword}
                        >
                          {addKeywordIcon}
                          Add keyword
                        </Button>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={12} lg={12}>
                    <Grid container spacing={0}>
                      <Grid item xs={12} md={12} lg={12}>
                        <Box display="flex">
                          <Box width="100%" spacing={1}>
                            {self.state.listKeywordsInElasticSearch.length !== 0 && (
                              <Typography className={classes.highlighedTerms} variant="subtitle1" gutterBottom>
                                <Switch
                                  color="primary"
                                  checked={self.state.showKeywordElasticSearch}
                                  onChange={self.handleOnChangeSwitch.bind(this)}
                                  size="small"
                                />
                                View keywords found
                              </Typography>
                            )}
                          </Box>
                          <Box textAlign="right" flexShrink={0}>
                            <Badge className={classes.highlighedColor} variant="dot"></Badge>
                            <Typography className={classes.highlighedTermsStrong} variant="subtitle1" gutterBottom>
                              Highlighed terms already exist in our keyword index
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={12} lg={12}>
                        <Collapse in={self.state.showKeywordElasticSearch}>
                          {self.state.mode === Constants.MODE_LOADED && (
                            <div>
                              {self.state.listKeywordsInElasticSearch.map(function (item, i) {
                                return <Chip key={i} label={item} variant="outlined" size="small" className={classes.chip} />;
                              })}
                            </div>
                          )}
                        </Collapse>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={4} md={4} lg={4}>
                <Grid container direction="column" alignItems="stretch">
                  <Grid item xs>
                    <Box style={{ width: "100%", height: "365px" }}>
                      <Typography variant="h6" gutterBottom>
                        Keywords to Add:
                      </Typography>
                      {self.state.listKeywordsToAdd.length > 0 && (
                        <div>
                          {self.state.listKeywordsToAdd.map(function (item, i) {
                            let categoriesText=item.CATEGORIES.length;
                            let keyworDetailText=item.KEYWORD + " (" + item.COUNTER_COMPANY + ") (C"+categoriesText+")";
                            return (
                              <Chip
                                key={i}
                                label={keyworDetailText}
                                variant="outlined"
                                className={classes.chipFound}
                                onDelete={self.handleDeleteKeyword.bind(self, i)}
                                onClick={self.handleAddCategories.bind(self, i, item.KEYWORD)}
                              />
                            );
                          })}
                        </div>
                      )}
                    </Box>{" "}
                  </Grid>
                  <Grid style={{ textAlign: "right" }}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={self.handleOnSave.bind(this)}
                      disabled={
                        (self.state.listKeywordsToAdd <= 0 && self.state.modeSave === Constants.MODE_LOADED) || self.state.modeSave === Constants.MODE_LOADING
                          ? true
                          : false
                      }
                    >
                      {self.state.modeSave === Constants.MODE_LOADING && <CircularProgress size={15} className={classes.progressSave} />}
                      Save
                    </Button>
                  </Grid>
                </Grid>
                <Snackbar
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  open={self.state.openSnackbar}
                  autoHideDuration={5000}
                  onClose={self.handleOnCloseSnackbar.bind(this)}
                >
                  <MuiAlert severity={self.state.typeAlert} elevation={6} variant="filled" className={classes.alert}>
                    {self.state.messageSnackbar}
                  </MuiAlert>
                </Snackbar>
                { 
                  showAddKeywordModal && (
                                        <WizardAddKeywordModal
                                            keywordText={this.state.keywordText}
                                            titleHeader={"Relate Keywords"}
                                            currentStep={1}
                                            saveInModalView={false}
                                            keywordsSelect={this.state.keywordsSelect}
                                            onClose={this.handleOnCloseAddKeywordModal.bind(this)}
                                            refreshRelateKeywords={this.handleRefreshRelateKeywords.bind(this)}
                                            className="modal-lg add-keyword" 
                                            returnObjects={this.returnObjects}
                                            />
                                    )
                }
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    );
  }
}
KeywordAnalyzer.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(keywordAnalyzerStyle)(KeywordAnalyzer);
